module.exports = __webpack_public_path__ + "img/kachel-VERLETZUNGEN_notfallspray.7c1af0dd.png";